import { render } from "./DropdownToggle.vue?vue&type=template&id=67efea1c&scoped=true"
import script from "./DropdownToggle.vue?vue&type=script&lang=js"
export * from "./DropdownToggle.vue?vue&type=script&lang=js"

import "./DropdownToggle.vue?vue&type=style&index=0&id=67efea1c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67efea1c"]])

export default __exports__